import { ETHW, ETC, ETF } from "./metaData";


export const featuredProjects = {
    [ETHW]: ['EthereumPoW', 'MetaMask', 'WENS | ETHW Name Service', 'TWIT', 'OpenW', 'Nuwton', 'Nswap', 'PowerSwap', 'Moon APE PoW Club', 'Beatles', 'Open Tigers', 'Crazy Snaili'],
    [ETC]: ['MetaMask', 'ETC Swap', 'DID Wallet', 'BitKeep', 'Nabox'],
    [ETF]: ['EthereumFair', 'MetaMask', 'BitKeep'],
};

export const trendingProjects = {
    [ETHW]: ['TWIT', 'EthereumPoW', 'MetaMask', 'WENS | ETHW Name Service', 'Beatles', 'Open Tigers', 'XEN', 'Nuwton', 'Moon APE PoW Club', 'Nswap', 'Crazy Snaili'],
    [ETC]: ['MetaMask', 'ETC Swap', 'DID Wallet', 'BitKeep', 'LikeNetwork', 'ClassZZ', 'Nabox'],
    [ETF]: ['EthereumFair', 'MetaMask', 'BitKeep', 'ClassZZ'],
};